/**
 * Takes a pixel number value
 * @param size
 * @returns a rem value or 0
 */
export const remCalc = (size: number) => (size === 0 ? 0 : `${size / 16}rem`);
